import * as React from 'react';
import { ReactNode } from 'react';
import { YoProject } from '@yakoffice/yakoffice-firebase';
import { ProjectLogo } from '@yakoffice/shared-components';

export interface ProjectNameAndImage {
    projectName: string;
    projectImage: ReactNode;
}

export function getProjectNameAndImage(projectId?: string, project?: YoProject): ProjectNameAndImage {

    const projectImageUrl = project ? project.imageUrl : require('../../../../images/yo.png');

    const projectInfo = {
        projectName: '',
        projectImage: <ProjectLogo src={projectImageUrl} alt="" />
    };

    switch (projectId) {
        case '1':
        case 'ppf':
        case 'ppk':
            projectInfo.projectName = 'Ping Pong Fury';
            return projectInfo;

        case '3':
        case 'ppfo':
            projectInfo.projectName = 'Ping Pong Fury Ops';
            return projectInfo;

        case '4':
        case 'dof':
            projectInfo.projectName = 'Darts Of Fury';
            return projectInfo;

        case '5':
        case 'ykt-bowl':
            projectInfo.projectName = 'Bowling Fury';
            return projectInfo;

        case 'ttt':
            projectInfo.projectName = 'Table Tennis Touch';
            return projectInfo;

        case 'prototype':
            projectInfo.projectName = 'Prototype';
            return projectInfo;
        default:
            projectInfo.projectName = 'Select a project';
            return projectInfo;
    }
}
